import ChainId from "./chainId";

type AddressConfig = Partial<Record<ChainId, `0x${string}`>>;

export const Permit2Address: Partial<Record<ChainId, `0x${string}`>> = {
  [ChainId.SEPOLIA]: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
};

interface EnvironmentAddresses {
  development: AddressConfig;
  test: AddressConfig;
  production: AddressConfig;
}

const getEnvironmentAddresses = (
  config: EnvironmentAddresses
): AddressConfig => {
  const env = process.env.REACT_APP_ENV || "dev";
  return config[env as keyof EnvironmentAddresses];
};

export const didAddresses = getEnvironmentAddresses({
  development: {
    [ChainId.SEPOLIA]: "0xd88BccAcbeF05e95A920f68E0942e27434651982",
  },
  test: {
    [ChainId.SEPOLIA]: "0x687115e26984c88D3392F633C2029fffe0d56592",
  },
  production: {
    [ChainId.SEPOLIA]: "0x3216044E5b59E7876D0cd818D44773eE547b4D08",
  },
});

export const AccountFactoryAddress = getEnvironmentAddresses({
  development: {
    [ChainId.SEPOLIA]: "0xA2AB55D87E7882B4639a8217D156c203b3b2a79E",
  },
  test: {
    [ChainId.SEPOLIA]: "0x9bAfBbAE90427CfE76E727e50be0496f4fE3dd2B",
  },
  production: {
    [ChainId.SEPOLIA]: "0xDc92e57fff026Cb0c4F06Ec39a190Cb848bD2B6c",
  },
});

export const TransfersAddress = getEnvironmentAddresses({
  development: {
    [ChainId.SEPOLIA]: "0xB5949401A4d2Ff39CF409A45e796b3d39e613762",
  },
  test: {
    [ChainId.SEPOLIA]: "0x6937b818596a4C4D2FbCFeB32b3d83701525Cec0",
  },
  production: {
    [ChainId.SEPOLIA]: "0x423054454a85fD0B82A86AF6d1f25537929EA022",
  },
});

export const UniswapV3FactoryAddress = getEnvironmentAddresses({
  development: {
    [ChainId.SEPOLIA]: "0x0227628f3F023bb0B980b67D528571c95c6DaC1c",
  },
  test: {
    [ChainId.SEPOLIA]: "0x0227628f3F023bb0B980b67D528571c95c6DaC1c",
  },
  production: {
    [ChainId.SEPOLIA]: "0x0227628f3F023bb0B980b67D528571c95c6DaC1c",
  },
});
